__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pdx-web-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(384))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(5903))), 1);
			register("@firebase/app", "0", () => (() => (__webpack_require__(7150))), 1);
			register("@firebase/auth", "1.7.9", () => (() => (__webpack_require__(498))), 1);
			register("@firebase/firestore", "4.7.3", () => (() => (__webpack_require__(1814))), 1);
			register("@firebase/storage", "0.13.2", () => (() => (__webpack_require__(9671))), 1);
			register("chart.js", "4.5.1", () => (() => (__webpack_require__(7304))), 1);
			register("i18next-browser-languagedetector", "8.2.1", () => (() => (__webpack_require__(1848))), 1);
			register("i18next-http-backend", "3.0.2", () => (() => (__webpack_require__(8914))), 1);
			register("i18next", "23.4.6", () => (() => (__webpack_require__(4978))), 1);
			register("react-chartjs-2", "5.3.1", () => (() => (__webpack_require__(6058))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-i18next", "15.4.1", () => (() => (__webpack_require__(4117))), 1);
			register("react-router-dom", "6.23.1", () => (() => (__webpack_require__(5475))), 1);
			register("react-router", "6.23.1", () => (() => (__webpack_require__(3550))), 1);
			register("react-spinners", "0.15.0", () => (() => (__webpack_require__(7439))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			register("web-vitals", "4.2.4", () => (__webpack_require__.e(488).then(() => (() => (__webpack_require__(2488))))));
			initExternal(5849);
			initExternal(9613);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};